import { List } from "immutable";

export default function ticketsForTournament (tickets, tournament) {
  if (tournament === undefined) {
    return List();
  }
  return tournament.get("tickets")
    .map((ticketId) => tickets.get(ticketId))
    .sort(compareTickets);
}

const compareTickets = (ticketA, ticketB) => {
  var scoreDiff = parseFloat(ticketB.get("score")) - parseFloat(ticketA.get("score")); // descending
  if (scoreDiff !== 0.0) {
    return scoreDiff;
  }
  return ticketA.get("id") - ticketB.get("id"); // ascending
};
